import React from "react";
import { certifications } from "../mock";
import { ShieldCheck, Award, FileCheck2 } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function Certifications() {
  const [ref, inView] = useReveal();
  return (
    <section id="certifications" className="kse-section bg-white">
      <div className="kse-container">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="kse-eyebrow">
            {certifications.eyebrow}
          </span>
          <h2 className="kse-h2">
            {certifications.title}
          </h2>
          <p className="text-slate-500 mt-4">{certifications.subtitle}</p>
        </div>

        <div ref={ref} className="grid md:grid-cols-2 gap-6">
          {certifications.items.map((c, i) => (
            <div
              key={c.standard}
              className={`relative bg-slate-50 rounded-3xl p-8 border border-slate-100 hover:shadow-xl transition-all overflow-hidden reveal ${inView ? "in-view" : ""}`}
              style={{ animationDelay: `${i * 0.12}s` }}
            >
              {/* seal */}
              <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full bg-[#1a2a6b]/5 flex items-center justify-center">
                <Award className="text-[#2b3aa0]/40" size={44} />
              </div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-2xl bg-[#1a2a6b] flex items-center justify-center">
                  <ShieldCheck className="text-white" size={24} />
                </div>
                <div>
                  <div className="text-xl font-extrabold text-[#1a2a6b] leading-none">{c.standard}</div>
                  <div className="text-[#2b3aa0] text-sm font-medium mt-1">{c.title}</div>
                </div>
              </div>

              <dl className="space-y-2 text-sm">
                <div className="flex gap-2">
                  <dt className="text-slate-400 w-24 shrink-0">Issuer</dt>
                  <dd className="text-slate-700 font-medium">{c.issuer}</dd>
                </div>
                <div className="flex gap-2">
                  <dt className="text-slate-400 w-24 shrink-0">Scope</dt>
                  <dd className="text-slate-700 font-medium">{c.scope}</dd>
                </div>
                <div className="flex gap-2">
                  <dt className="text-slate-400 w-24 shrink-0">Reference</dt>
                  <dd className="text-slate-700 font-medium">{c.number}</dd>
                </div>
              </dl>

              <p className="flex items-start gap-2 text-slate-500 text-sm mt-4 pt-4 border-t border-slate-200">
                <FileCheck2 size={16} className="text-[#2b3aa0] mt-0.5 shrink-0" /> {c.note}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
